module.exports = {
  siteTitle: 'Doumi Athmane',
  siteDescription:
    'Doumi Athmane Software engineer, Fullstack developer, based in Algeria, specializing in building (and occasionally designing) exceptional websites, applications, and everything in between.',
  siteKeywords:
    'Doumi Athmane, software engineer, web developer, javascript, python, php, django, ESI, Algiers, Algeria',
  siteUrl: 'https://doumi-athmane.github.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: '',
  googleVerification: '',
  name: 'Doumi Athmane',
  location: 'Algiers, Algeria',
  email: 'doumiathmane0@gmail.com',
  github: 'https://github.com/Doumi-Athmane',
  twitterHandle: '@',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/Doumi-Athmane',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/athmane-doumi-a0875816b/',
    },
    {
      name: 'Facebook',
      url: 'https://m.facebook.com/people/Athmane-Doumi/100014173151483/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Skills',
      url: '/#skills',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#FBA834',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
